import { Resource } from "./resource";

export class ResourceMin extends Resource {
  constructor() {
    super(null, {
      IRI: "notNull"
    });
  }
}
